<template>
  <div class="product">
    <div class="banner">
      <div class="title">智能创意供给</div>
      <div class="desc">
        <section>平面/插画、视频/动画、直播/电商、品牌设计等8大创意服务类型以及150+创意服务形式，</section>
        <section>亿级版权素材库，为品牌提供多元优质的内容创意供给和数字化交付</section>
      </div>
       <router-link target="_blank"  to='/contact'>
        <div class="button">立即体验
          <i class="el-icon-right"></i>
        </div>
      </router-link>

    </div>
    <div class="context">
      <div class="row">
        <div class="introduce right">
          <div class="iheader">
            <img src="https://respool.isheji.com/isheji/static/qiye/image/home/path_card_1.png">
            <div class="iTitle">
              <div class="bold">创意供给平台</div>
              <div class="thin">8大创意类型150+创意形式</div>
            </div>
          </div>
          <div class="idesc">
            <section>3000+海内外独立创意人/工作室，为品牌提供多元优质的内容创意供给。</section>
            <section>平面/插画、视频/动画、直播/电商、品牌设计、UI、包装、IP、整合营销</section>
          </div>

            <div class="button" @click="goIdea">立即体验
              <i class="el-icon-right"></i>
            </div>

        </div>
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/product/supply/1.png">
      </div>
      <div class="row">
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/product/supply/2.png">
        <div class="introduce left">
          <div class="iheader">
            <img src="https://respool.isheji.com/isheji/static/qiye/image/home/path_card_2.png">
            <div class="iTitle">
              <div class="bold">创意素材中心</div>
              <div class="thin">亿级平面、视频、模版商业授权</div>
            </div>
          </div>
          <div class="idesc">
            <section>视觉中国战略合作伙伴，正版商业授权，</section>
            <section>为创作者提供上亿级别高质量版权素材内容，可供在线设计制作</section>
          </div>

            <router-link target="_blank" to="/contact">
              <div class="button">
                立即体验
                <i class="el-icon-right"></i>
              </div>
            </router-link>
        </div>
      </div>
    </div>
     <banner></banner>
  </div>
</template>
<script>
import banner from '@/components/productBanner.vue'
export default {
  name: 'supply',
  components: {
    banner,
  },
  methods: {
    goIdea(){
      window.open('https://idea.isheji.com/', '_blank');
    },
    goSc(){
      window.open('https://sc.isheji.com/', '_blank');
    }
  },
}
</script>
<style lang="scss" scoped>
.product{
    width: 100%;
    min-width: 1400px;
    .banner{
      text-align: center;
      background-image: url("https://respool.isheji.com/isheji/static/qiye/image/product/supply/banner.png");
      width: 100%;
      min-width: 1400px;
      height: 460px;
      background-size: cover;
      background-position-x: center;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    padding-top: 60px;
      .title{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 45px;
      }
      .desc{
        margin-top: 20px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
        margin-bottom: 32px;
      }

    }
    .context{
      padding-top: 120px;
      width: 1200px;
      margin: auto;
      .row{
        display: flex;
        margin-bottom: 115px;
        align-items: center;
        .left{
          margin-left: 142px;
        }
        .right{
          margin-right: 142px;
        }
        .introduce{
          .iheader{
            display: flex;
            align-items: center;
            img{
              width: 60px;
              height: 60px;
              border-radius: 8px;
            }
            .iTitle{
              margin-left: 18px;
              display: flex;
              flex-direction: column;
              justify-content: center;

              .bold{
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 28px;
              }
              .thin{
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 22px;
                margin-top: 5px;
              }
            }
          }
          .idesc{
            margin-top: 24px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6E6C76;
            line-height: 20px;
            margin-bottom: 32px;
          }
        }
        .img{
          width: 595px;
        }

      }
    }
     .button{
        width: 126px;
        height: 44px;
        background: #5A2DF5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
          .el-icon-right{
            display: none;
            margin-left: 8px;
          }
        &:hover{
          .el-icon-right{
            display: block;
            color: #FFFFFF;
            margin-left: 8px;
          }
        }
      }
}
</style>
